import { render, staticRenderFns } from "./DashSetup.vue?vue&type=template&id=3dfd9d19&scoped=true&"
import script from "./DashSetup.vue?vue&type=script&lang=js&"
export * from "./DashSetup.vue?vue&type=script&lang=js&"
import style0 from "./DashSetup.vue?vue&type=style&index=0&id=3dfd9d19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd9d19",
  null
  
)

export default component.exports